module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/check-e3a9a937f4987a38f8cbd7b9cc9ac7e9.svg";